import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  billingFrequencyRadioGroup: {
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  billingFrequencyOption: {
    alignItems: 'center',
    display: 'flex',

    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: 'var(--theme-highlight-color)',
    },
  },
}));

export default useStyles;
